export const EM_VALUE = 16;
export const IMAGE_QUALITY = '80';
